/**
 * Created with IntelliJ IDEA.
 * User: dkoehler
 * Date: 24.08.12
 * Time: 17:03
 * To change this template use File | Settings | File Templates.
 */

import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class PackageDownloadEvent extends BasicTrackingEvent {
    public gameId: number;
    public networkId: number;
    public instanceID: number;
    public playerID: number;
    public accountID: string;
    public countryCode: string;
    public gameSwfLoadingTime: number;

    public downloadSize: number;
    public downloadDuration: number;
    public downloadURL: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.gameId = this.gameId;
        vars.networkId = this.networkId;
        vars.instanceId = this.instanceID;
        vars.playerId = this.playerID;

        vars.var_1 = this.downloadSize;
        vars.var_2 = this.downloadDuration;
        vars.var_3 = this.accountID;
        vars.var_4 = this.gameSwfLoadingTime;
        vars.var_data = this.downloadURL + ";" + this.countryCode;
        return vars;
    }
}
